import { UI } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import { DrawerScreenProps } from '@react-navigation/drawer';
import React, { useCallback } from 'react';
import { ScrollView } from 'react-native';

import { SignedInRootStackParamList } from '../../../routes/types';

import { SubscriptionSolicitationContent } from './components/SubscriptionSolicitationContent';

export const SubscriptionSolicitation: React.FC<
  DrawerScreenProps<SignedInRootStackParamList, 'SubscriptionSolicitation'>
> = ({ navigation, route }) => {
  const responsiveWidth = useBreakpointValue({
    base: 1,
    sm: 1,
    md: 0.42,
  });

  const goBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    }
  }, [navigation]);

  return (
    <UI.SliderModal width={responsiveWidth} onDismiss={goBack}>
      <ScrollView>
        <SubscriptionSolicitationContent
          quantity={route.params.quantity}
          customer={route.params.customer}
          subscription={route.params.subscription}
          goBack={goBack}
        />
      </ScrollView>
    </UI.SliderModal>
  );
};
